import React, { useState } from 'react';

// Comps
import AccountForm from '../AccountForm/AccountForm';
import AccountFormHeader from '@project-stories/ecommerce/Account/AccountFormHeader/AccountFormHeader';

type Props = {
    section: any;
    signUpFields: any;
    headerColorSchema?: string;
    blockSettings?: any;
};

export const LoginAndRegister = ({ section, signUpFields, headerColorSchema, blockSettings }: Props) => {
    const {
        // Typography
        title_type,
        title_type_mobile,
        body_type,
        body_type_mobile,
    } = section;

    // Extract block settings
    const loginForm = blockSettings?.loginForm || {};
    const registerBlock = blockSettings?.registerCta || {};

    const titleType = `${title_type_mobile} ${title_type}-lg`;
    const taglineType = `${body_type_mobile} ${body_type}-lg`;

    // States
    const [showCustomFields, setShowCustomFields] = useState(true);

    return (
        <>
            {/* Login */}
            <div className='md:sticky top-[calc(var(--header-height)+1rem)]'>
                <AccountFormHeader
                    title={loginForm.title_login}
                    titleType={titleType}
                    tagline={loginForm.tagline_login}
                    taglineType={taglineType}
                    colorSchema={loginForm.header_color_schema || headerColorSchema}
                />

                <AccountForm
                    section={{
                        ...section,
                        ...loginForm
                    }}
                    isRegister={false}
                    showCustomFields={showCustomFields}
                />
            </div>

            {/* Register */}
            <div className='md:sticky top-[calc(var(--header-height)+1rem)]'>
                <AccountFormHeader
                    title={registerBlock.title_register_cta}
                    titleType={titleType}
                    tagline={registerBlock.tagline_register_cta}
                    taglineType={taglineType}
                    colorSchema={headerColorSchema}
                />

                <AccountForm
                    section={section}
                    isRegister={true}
                    showCustomFields={showCustomFields}
                    signUpFields={signUpFields}
                />
            </div>
        </>
    );
};

export default LoginAndRegister;